
/**
  ブランクページ（初期表示用）
*/
<template>
  <v-ons-page>
    <div class="content">
      <div class="page_container" style="position:relative">
      
        <div class="wrapper">
          <h1>
            <img src="../assets/img/copy_easy.svg" width="90%">
          </h1>
          <h2>
            <a class="btn_line_friend" @click="gotoLinePage" target="_blank">
              <img data-v-dc90c1a6="" src="../assets/img/btn_friend.svg" alt="友だち追加">
            </a>
            <img class="copy_friend" src="../assets/img/copy_friend.svg">
          </h2>
          
          <a class="btn_start"  @click="gotoHome" id="menu">
            <img src="../assets/img/btn_start.svg" alt="利用を始める">
          </a>
        </div>
      </div>
      
    </div>
  </v-ons-page>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: 'blank',
  data() {
    return {}
  },
  created: function() {
    if(this.line_token!=''){
      this.setSessionToken()
      this.navigateWPPage('menu_top')
    }
  },
  computed: {
    ...mapGetters([
      'line_token',
      'ShopCode',
      'ShopIP',
      'ApiVersion',
      'PortNo',
      'SlipNo',
      'SlipDate',
      'LineFriendURL',
      ]),
  },
  methods: {
    ...mapActions([
      'navigateWPPage',
      'setSessionToken',
      'setLineToken',
    ]),
    gotoLinePage(){
      this.setLineToken()
      window.open(this.LineFriendURL)
    },
    gotoHome(){
      this.setLineToken()
      this.setSessionToken()
      this.navigateWPPage('menu_top')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss" scoped>
@import "../assets/sass/base.scss";
/*
.content.start{
    padding: 15% 10% 15%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    background: url(../assets/img/home_bg.jpg) no-repeat!important;
    background-size: cover!important; 
    background-position: center;
    color: $base-font-color;
  }
*/
.content{
  box-sizing: border-box;
  padding: 0;
  background: #f7e9d3!important;
}
.page_container{
  position: relative;
  width: 100%;
  height: 100%;
}

.wrapper{
  background: url(../assets/img/line_bg.jpg) no-repeat;
  background-size: cover;
  background-position: center;
  border-radius: 20px;
  padding: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  position: absolute;
  top: 15px;
  bottom: 15px;
  left: 15px;
  right: 15px;
  
  img{
    max-width: 95%;
    margin-bottom: 10px;
  }
}

h1,h2{
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0;
  margin-bottom: 20px;
}

h1{
  position: absolute;
  top: 10vh;
  width: 80%;
  left: 0;
  right: 0;
  margin: auto;
}

h2{
  position: absolute;
  top: 40vh;
  left: 0;
  right: 0;
  margin: auto;
  width: 90%;
  text-align: center;
}
.copy_friend{
  width: 80%;
}
.btn_start{
  position: absolute;
  bottom: 10vh;
  left: 0;
  right: 0;
  margin: auto;
  width: 90%;


}


/****************************/
</style>



// WEBPACK FOOTER //
// src/pages/LineFriendPage.vue